<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'print.test.label' | translate }}</h2>
</div>

<form [formGroup]="form" (ngSubmit)="submit()" class="print-test-form">
	<mat-form-field appearance="outline">
		<mat-label>{{ 'print.test.printer' | translate }}</mat-label>
		<mat-select formControlName="printer">
			<mat-option *ngFor="let printer of printers" [value]="printer.self">
				{{ printer.alias }}
			</mat-option>
		</mat-select>
	</mat-form-field>

	<mat-radio-group formControlName="mode" class="print-test-mode-toggle">
		<mat-radio-button value="url">{{ 'print.test.mode.url' | translate }}</mat-radio-button>
		<mat-radio-button value="template">
			{{ 'print.test.mode.template' | translate }}
		</mat-radio-button>
	</mat-radio-group>

	<mat-form-field *ngIf="isUrlMode" appearance="outline" class="print-test-textarea">
		<mat-label>{{ 'print.test.urls' | translate }}</mat-label>
		<textarea matInput formControlName="urls" rows="6" [placeholder]="'print.test.urls-placeholder' | translate"></textarea>
	</mat-form-field>

	<ng-container *ngIf="!isUrlMode">
		<mat-form-field appearance="outline">
			<mat-label>{{ 'print.test.template' | translate }}</mat-label>
			<mat-select formControlName="template">
				<mat-option *ngFor="let template of templates" [value]="template.self">
					{{ template.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>

		<mat-form-field appearance="outline" class="print-test-textarea">
			<mat-label>{{ 'print.test.data' | translate }}</mat-label>
			<textarea matInput formControlName="data" rows="10" [placeholder]="'print.test.data-placeholder' | translate"></textarea>
		</mat-form-field>
	</ng-container>

	<button mat-flat-button color="primary" type="submit" [disabled]="isSubmitting">
		{{ 'print.test.submit' | translate }}
	</button>
</form>
